import { useState } from 'react'

const getPlacowkaId = item => item?.placowkaId || item?.placowka?._id || item?.placowka?.id

export default function usePlacowkiSelection() {
	const [selectedPlacowki, setSelectedPlacowki] = useState(new Set())

	const handleSelectAll = (checked, rows) => {
		if (checked) {
			setSelectedPlacowki(new Set(rows.map(getPlacowkaId).filter(Boolean)))
		} else {
			setSelectedPlacowki(new Set())
		}
	}

	const handleSelectPlacowka = (placowkaId, checked) => {
		const next = new Set(selectedPlacowki)
		if (checked) {
			next.add(placowkaId)
		} else {
			next.delete(placowkaId)
		}
		setSelectedPlacowki(next)
	}

	const clearSelection = () => setSelectedPlacowki(new Set())

	const getSelectionState = rows => {
		const total = rows.length
		const selectedCount = rows.filter(item => selectedPlacowki.has(getPlacowkaId(item))).length
		return {
			isAllSelected: total > 0 && selectedCount === total,
			isIndeterminate: selectedCount > 0 && selectedCount < total,
		}
	}

	return {
		selectedPlacowki,
		handleSelectAll,
		handleSelectPlacowka,
		clearSelection,
		getSelectionState,
		getPlacowkaId,
	}
}
